import React, { CSSProperties } from 'react';
import { mapOriginatingSystemToSource, stripListingIdPrefix } from '../../../utilities/util';
import { isCapCenterOffice, isCapCenterListOffice } from '../../../utilities/util';
import { Property } from '../../../interfaces/interfaces';
import {baseUrl, baseRealtyUrl, getUrlWithUtmQueryString } from '@capcenter/shared';
import { PresentedByPanel } from './PresentedBy';

interface ListingDetailsProps {
	property: Property,
	detailListStyle: CSSProperties,
	service: string | undefined,
	agreement: string | undefined,
	mlsListingId: string | undefined,
	mlsSystem: string | undefined
	mlsStatus: string | undefined,
	listAgent: string | undefined,
	listOfficeName: string | undefined,
	listOfficeMlsId: string | undefined,
	buyerOfficeMlsId: string | undefined,
	originatingSystemName: string | undefined,
}

const ListingDetails = ({property, detailListStyle, service, agreement, mlsListingId, mlsSystem, mlsStatus, listAgent, listOfficeName, listOfficeMlsId, buyerOfficeMlsId, originatingSystemName} : ListingDetailsProps) => {
	return (
		<React.Fragment>
			<article className="property-details__listing-info w-100 my-0 my-lg-4 p-3 container">
				<h2 className="cc-font-weight--bold mb-1 h5">
					<i className="fad fa-newspaper cc-color--secondary me-2" />
					Listing Details
				</h2>
				{PresentedByPanel(property, isCapCenterListOffice(listOfficeName, listOfficeMlsId, originatingSystemName), isCapCenterOffice(buyerOfficeMlsId, originatingSystemName))}
				<div className="g-0 fw-light">
					<div className="row">
						<ul className='col-12 col-md-6 d-none d-md-block' style={detailListStyle}>
							{service ? <li><span className="cc-font-weight--normal">Service:</span> {service}</li> : ''}
							{agreement ? <li><span className="cc-font-weight--normal">Agreement:</span> {agreement}</li> : ''}
							{mlsListingId ? <li><span className="cc-font-weight--normal">MLS ID:</span> {stripListingIdPrefix(mlsListingId)}</li> : ''}
						</ul>
						<ul className='col-12 col-md-6 d-block d-none d-md-block' style={detailListStyle}>
							{mlsSystem ? <li><span className="cc-font-weight--normal">MLS System:</span> {mapOriginatingSystemToSource[`${mlsSystem}`]}</li> : ''}
							{mlsStatus ? <li><span className="cc-font-weight--normal">MLS Status:</span> {mlsStatus}</li> : ''}
						</ul>
						<ul className='col-12 d-block d-md-none' style={detailListStyle}>
							{service ? <li><span className="cc-font-weight--normal">Service:</span> {service}</li> : ''}
							{agreement ? <li><span className="cc-font-weight--normal">Agreement:</span> {agreement}</li> : ''}
							{mlsListingId ? <li><span className="cc-font-weight--normal">MLS ID:</span> {stripListingIdPrefix(mlsListingId)}</li> : ''}
							{mlsSystem ? <li><span className="cc-font-weight--normal">MLS System:</span> {mapOriginatingSystemToSource[`${mlsSystem}`]}</li> : ''}
							{mlsStatus ? <li><span className="cc-font-weight--normal">MLS Status:</span> {mlsStatus}</li> : ''}
						</ul>
					</div>

					{ isCapCenterListOffice(listOfficeName, listOfficeMlsId, originatingSystemName) &&
					<>
						<div className="row">
							<div className="col-12">
								<span className="cc-font-weight--bold">Listed with <a href={getUrlWithUtmQueryString(`${baseRealtyUrl}/best-realtor-agency-sell-home`)}>CapCenter Realty</a></span>
							</div>
						</div>
					</>
					}

					{ isCapCenterOffice(buyerOfficeMlsId, originatingSystemName) &&
					<>
						<div className="row">
							<div className="col-12">
								<span className="cc-font-weight--bold">Purchased with <a href={getUrlWithUtmQueryString(`${baseRealtyUrl}/best-realtor-agency-buy-home`)}>CapCenter Realty</a></span>
							</div>
						</div>
					</>
					}

          { listAgent &&
					<>
            <div className="row">
              <div className="col-12">
                <span className="cc-font-weight--normal">Listed by: {listAgent} {listOfficeName && `, ${listOfficeName}`}</span>
              </div>
            </div>
          </>
          }

					<div className="row">
						<div className="col-12">
							<p>
								Are you looking for the best realtor near you? <br className='d-md-none d-block'/> <a href={getUrlWithUtmQueryString(`${baseRealtyUrl}/find-best-local-realtor`)} target="_blank" rel="noreferrer">See our best local realtors</a>
								<br/>
								Not sure where to start? <br className='d-md-none d-block'/> <a href={getUrlWithUtmQueryString(`${baseRealtyUrl}/get-preapproved-for-a-home-loan`)}>Get pre-approved for a no closing cost mortgage</a>
							</p>
						</div>
					</div>
				</div>
			</article>
		</React.Fragment>
	);
};

export default ListingDetails;
